import styles from "./TransportAgreement.module.scss";

const ChangesAndOrganizerInfo = () => {
  return (
    <div>
      <br />
      <div className={styles.Section}>
        <div className={styles.MainConditions}>
          <strong>Table: Change Compensation Fee</strong>
          <div>
            <table className={styles.ChangeFeeTable}>
              <tbody>
                <tr>
                  <td colSpan={1} rowSpan={2}>
                    Change requiring payment of the compensation for change
                  </td>
                  <td colSpan={2} rowSpan={1}>
                    Rate (%) per change
                  </td>
                </tr>
                <tr>
                  <td colSpan={1} rowSpan={1}>
                    Prior to the commencement of the tour
                  </td>
                  <td colSpan={1} rowSpan={1}>
                    After the commencement of the tour
                  </td>
                </tr>
                <tr>
                  <td colSpan={1} rowSpan={1}>
                    1. Changes in tour start or end dates specified in the
                    Contract Document
                  </td>
                  <td colSpan={1} rowSpan={1}>
                    1.50%
                  </td>
                  <td colSpan={1} rowSpan={1}>
                    3.00%
                  </td>
                </tr>

                <tr>
                  <td colSpan={1} rowSpan={1}>
                    2. Changes in destination or entry to tourist spots and/or
                    facilities (including restaurants), specified in the
                    Contract Document
                  </td>
                  <td colSpan={1} rowSpan={1}>
                    1.00%
                  </td>
                  <td colSpan={1} rowSpan={1}>
                    2.00%
                  </td>
                </tr>

                <tr>
                  <td colSpan={1} rowSpan={1}>
                    3. Changes in class of transport facilities or facilities as
                    stated in the Contract Document to those of lower cost
                    (limited to cases when the total price after change to class
                    of transport facilities or facilities becomes lower than the
                    amount stated in the Contract Document).
                  </td>
                  <td colSpan={1} rowSpan={1}>
                    1.00%
                  </td>
                  <td colSpan={1} rowSpan={1}>
                    2.00%
                  </td>
                </tr>

                <tr>
                  <td colSpan={1} rowSpan={1}>
                    4. Changes in the type of transport facility or of the name
                    of the company operating them as specified in the Contract
                    Document
                  </td>
                  <td colSpan={1} rowSpan={1}>
                    1.00%
                  </td>
                  <td colSpan={1} rowSpan={1}>
                    2.00%
                  </td>
                </tr>

                <tr>
                  <td colSpan={1} rowSpan={1}>
                    5. Changes to the flight at the airport in the location of
                    the commencement of the tour in Japan or to the flight at
                    the airport in the location of the end of the tour as
                    specified in the Contract Document
                  </td>
                  <td colSpan={1} rowSpan={1}>
                    1.00%
                  </td>
                  <td colSpan={1} rowSpan={1}>
                    2.00%
                  </td>
                </tr>

                <tr>
                  <td colSpan={1} rowSpan={1}>
                    6. Changes from direct flights between Japan and the foreign
                    country specified in the Contract Document to connecting
                    flights or indirect flights
                  </td>
                  <td colSpan={1} rowSpan={1}>
                    1.00%
                  </td>
                  <td colSpan={1} rowSpan={1}>
                    2.00%
                  </td>
                </tr>

                <tr>
                  <td colSpan={1} rowSpan={1}>
                    7. Changes in the type or name of accommodation facility as
                    specified in the Contract Document
                  </td>
                  <td colSpan={1} rowSpan={1}>
                    1.00%
                  </td>
                  <td colSpan={1} rowSpan={1}>
                    2.00%
                  </td>
                </tr>

                <tr>
                  <td colSpan={1} rowSpan={1}>
                    8. Changes in type of rooms, facilities, the view, or other
                    room condition at accommodation facilities as specified in
                    in the Contract Document
                  </td>
                  <td colSpan={1} rowSpan={1}>
                    1.00%
                  </td>
                  <td colSpan={1} rowSpan={1}>
                    2.00%
                  </td>
                </tr>

                <tr>
                  <td colSpan={1} rowSpan={1}>
                    9. Changes among the above items that were specified in the
                    tour title in the contract document
                  </td>
                  <td colSpan={1} rowSpan={1}>
                    2.50%
                  </td>
                  <td colSpan={1} rowSpan={1}>
                    5.00%
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div>
          <strong>Customer Responsibility</strong>
          <ul>
            <li>
              If we suffer damage due to your intentional or negligent act, you
              must compensate for the damage.
            </li>
            <li>
              You must utilize the information provided by us and strive to
              understand the rights and obligations of travelers and the
              contents of the organized travel contract as stated in the
              contract document.
            </li>
            <li>
              If, after the start of the trip, you recognize that the travel
              services stated in the contract document are different from those
              provided, you must promptly report this to us or the travel
              service provider at the travel destination.
            </li>
          </ul>

          <br />
          <strong>Customer Substitution</strong>
          <ul>
            <li>You can substitute with another person if we approve.</li>
          </ul>

          <br />
          <strong>Reporting Accidents, etc.</strong>
          <ul>
            <li>
              If an accident occurs during the trip, please immediately notify
              the contact provided in the final itinerary. (If there are
              circumstances that prevent you from notifying, please notify as
              soon as those circumstances cease to exist.)
            </li>
          </ul>
          <br />
          <strong>About the Organized Tour Travel Contract Terms</strong>
          <ul>
            <li>
              Matters not specified in these conditions are governed by our
              Travel Agency Agreement (Organized Tour Travel Contract Section).
            </li>
            <li>
              If you wish to receive our Travel Agency Agreement, please request
              it from us.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ChangesAndOrganizerInfo;
